// Centralized color definitions for the project
// Usage: import { COLORS } from './colors';

export const COLORS = {
  primaryBlue: '#1976d2',
  lightBlue: '#e3f2fd',
  darkBlue: '#0066FF',
  black: '#000',
  white: '#FFFFFF',
  darkGray: '#45484A',
  midGray: '#666',
  borderGray: '#9D9EA3',
  textGray: '#252525',
  darkBlack: '#222',
  secondaryGrey: '#767676',


  // TransactionHistoryTable status colors
  statusApproved: '#088764',
  statusApprovedBg: '#EBF9F5',
  statusPending: '#007BC3',
  statusPendingBg: '#ECF6FC',
  statusDeclined: '#CD2026',
  statusDeclinedBg: '#FEEFF0',
  statusCanceledBg: '#f3f3f3',
  statusCanceledBorder: '#bbb',
  statusCanceledIcon: '#888',
  cancelButton: '#e14d4d',
  filtersButton: '#205D70',
  filterBtnBorder: '#2F7185',
  filterBtnBg: '#F6FDFF',
  tableHeaderBg: '#E8EEF0',
  tableHeaderBorder: '#D9D9D9',
  tableRowEvenBg: '#F5F5F5',
  tableRowBorder: '#E8EEF0',
  tableCellBorder: '#E0E0E0',
  successGreen: '#30B130',
  successBg: '#E6F7E6',
  errorRed: '#DF1B41',
  errorBg: '#FCE4E8',
  lightGrey: '#E0E0E0',
  grey: '#697386',
  paleBlue: '#f8fafc',
  darkText: '#1a1f36',
  paleGrey: '#eaecf0',
  hoverBlue: '#0052CC',
  textGrey: '#666',
  inputBorder: '#E0E0E0',
  darkGrey: '#30313d',
  boxShadow: 'rgba(0, 0, 0, 0.05)',
  requiredAsterisk: '#d32f2f',
};
